var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5487 7.73329C10.6243 7.80415 10.6667 7.90024 10.6667 8.00044C10.6667 8.10064 10.6243 8.19673 10.5487 8.26759L6.68724 11.8898C6.63091 11.9425 6.55921 11.9783 6.48119 11.9928C6.40317 12.0074 6.32231 11.9999 6.24881 11.9713C6.17531 11.9428 6.11247 11.8945 6.06819 11.8325C6.02392 11.7705 6.0002 11.6976 6.00002 11.623L6.00002 4.3786C5.99988 4.30377 6.02343 4.23058 6.06768 4.16832C6.11193 4.10605 6.1749 4.05752 6.24859 4.02886C6.32229 4.00021 6.4034 3.99272 6.48163 4.00736C6.55987 4.02199 6.63171 4.05809 6.68805 4.11107L10.5487 7.73329Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMenu);
export default __webpack_public_path__ + "static/media/ExpandMenu.6928ef869c122dc8bfa6b826b03fffa2.svg";
export { ForwardRef as ReactComponent };